import { Component} from '@angular/core';
import { Utility } from '../shared/utility/utility';
import { environment } from '../../environments/environment';
import { Route, Router } from '@angular/router';


@Component({
  selector: 'app-blocked-user',
  templateUrl: './blocked-user.component.html',
  styleUrls: ['./blocked-user.component.scss']
})
export class BlockedUserComponent {
  mediaUrlPath = environment.mediaPath;
  siteUrlPath: string = environment.siteUrl;
  xSaleSiteHref = 'https://record.njordaffiliates.com/_2aODD0XAaddmXWbCIrA3VWNd7ZgqdRLk/5/'

  constructor(private utils:Utility) { }

  ngOnInit(): void {
  }
  closeModal(){
    this.utils.closeModal('blockedUserModal')
  }
  navigateToSite(){
   window.location.href = this.xSaleSiteHref;
  }
}
